<template>
  <li class="tree" :class="treeItemCss()" >
    <div class="side-nav-item" :class="navItemCss()">

      <div 
        class="side-nav-item-header"
      >
        <a 
          class="name"
          href="#"
          @click.prevent="onNavClick()"
          :id="getIdFromLocationData(locationArray) ? 'tuka-sidebar-' + getIdFromLocationData(locationArray) : false"
        >
          <!-- <span class="location-data-formatted">{{formattedLocationData(locationArray)}}</span> -->
          <span class="location-data-formatted">{{handleHeaderNumber(locationArray,item.name)}}</span>
          <span class="location-data-title" v-html="item.name" />
        </a>
      </div>

      <div class="display-accordion-button">
        <button
          v-if="displayAccordionButton()"
          class='accordion-button'
          :class="accordion.open ? 'icon-arrow-up' : 'icon-arrow-down'"
          @click="toggleAccordion()"
          :aria-label="accordion.open ? $t('tuka.navigation.accordion_open') : $t('tuka.navigation.accordion_closed')"
          :aria-expanded="accordion.open ? 'true' : 'false'"
          :aria-controls="'accordion-' + id"
        >
        </button>
      </div>
      
    </div>

    <!-- Items not part of main content and list numbering, e.g. "Johdanto" -->
    <ul 
      v-if="item.infoItems && item.infoItems.length"
      :id="'accordion-' + id"
      class="info-item "
      :class="accordionCss(index, accordion.open)"
    >
      <list-tree v-for="(singleInfoItem, singleInfoItemIndex) in item.infoItems" :key="id + '-info-' + singleInfoItemIndex" 
          :item="decodeContent(singleInfoItem)"
          :index="index + 1"
          :singleInfoItemIndex="singleInfoItemIndex"
          :locationArray="singleInfoItem.locationData"
          :parentsArray="parentsArrayPush(parentsArray)"
          :parentHasAccordion="displayAccordionButton()"
      />
    </ul>

    <!-- Items part of main content and numbering, e.g. "3 Julkinen talous" -->
    <ul 
      v-if="item.items && item.items.length"
      :id="'accordion-' + id"
      class="numbered-item "
      :class="accordionCss(index, accordion.open)"
    >
      <list-tree v-for="(singleItem, singleItemIndex) in item.items" :key="id + '-' + singleItemIndex" 
          :item="decodeContent(singleItem)"
          :index="index + 1"
          :singleItemIndex="singleItemIndex"
          :locationArray="singleItem.locationData"
          :navigationIndex="singleItem.navigationIndex"
          :parentsArray="parentsArrayPush(parentsArray)"
          :parentHasAccordion="displayAccordionButton()"
      />
    </ul>

  </li>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { areArraysEqual, isArrayIncluded, formattedLocationData, getIdFromLocationData, createUrlString } from "../store/helpers";

import * as http from "../http";

export default {
  name: "ListTree",
  props: {
    item: Object,
    index: Number,
    singleItemIndex: Number,
    singleInfoItemIndex: Number,
    locationArray: Array,
    navigationIndex: String,
    parentsArray: Array,
    parentHasAccordion: Boolean,
  },
  data() {
    return {
      id: this._uid,
      accordion: {
        open: false
      },
      currentItem: false,
      activeItem: false
    };
  },
  watch: {
    // If themeWords filter have been changed, change accordion state
    'themeWords': {
      handler(newValue, oldValue) {
        if (this.getFilters.themeWords) {
          // Check if item or its child items are active and should be shown when using themewords filter 
          if (this.item.directChildItemsActive || this.item.childItemsActive) {
            this.accordion.open = true;
          } else {
            this.accordion.open = false;
          }
        }
      },
      deep: true
    },
    'currentItemLocationData': {
      handler(newValue, oldValue) {

        // If last item is 0 check for direch match or partial match for child items
        let getMultiple = false;
        if (newValue && newValue.length) {
          if (newValue[newValue.length - 1] === "0") {
            getMultiple = true;
          }
        }

        let arraysEqual = false;
        let arrayIncluded = false;
        if (getMultiple) {
          arrayIncluded = isArrayIncluded(newValue, this.locationArray);

          // If getting multiple items, check current item for equal array without -1 suffix
          let tempArraysEqual = [...newValue];
          tempArraysEqual.pop();
          arraysEqual = areArraysEqual(tempArraysEqual, this.locationArray);
        } else {
          arraysEqual = areArraysEqual(newValue, this.locationArray);
        }

        // Direct match of request, e.g. /2/0 (multiple) or /1 (single)
        if (arraysEqual) {
          this.currentItem = true; // set info into component, value available during rendering
          this.item.currentItem = true; // set info into sidebar state, available for further mutations
          
          this.activeItem = true;
          this.item.activeItem = true;
          
          this.accordion.open = true;

        // Partial match, item is a child item of direct match (e.g. /2/1 and /2/1/3 are partial matches for /2/0)
        } else if (arrayIncluded) {
          this.currentItem = false;
          this.item.currentItem = false;

          this.activeItem = true;
          this.item.activeItem = true;

        // No match
        } else {
          this.currentItem = false;
          this.item.currentItem = false;
          
          this.activeItem = false;
          this.item.activeItem = false;

        }       
      },
      deep: true
    },
    'item.childItemsActive': {
      handler(newValue, oldValue) {
        this.accordion.open = this.item.childItemsActive;
      }
    },
    'item.childItemsThemeWordsActive': {
      handler(newValue, oldValue) {
        this.accordion.open = this.item.childItemsThemeWordsActive;
      }
    },
    'isCurrentlyVisible': {
      handler(newValue, oldValue) {

        // If item.contentId matches visibleContentId scroll sidebar item into view
        if (newValue) {
          
          // Wait for scrolling to be released befory trying sidebar scroll
          if (!this.scrollingReserved) {
            this.$nextTick(() => {

              let sidebarContainer = this.$el.offsetParent; // First positioned parent container of item
              let offsetTop = this.$el.offsetTop; // Position within parent container
              if (sidebarContainer) {
                sidebarContainer.querySelector(".initial").scrollTo({
                  top: offsetTop + -300,
                  behavior: 'smooth'
                });
              }

            });
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(["getheadersWithoutOrderNum","getFilters", "getSettings", "themeWords", "currentItemLocationData", "scrollingReserved", "visibleContentId"]),
    isCurrentlyVisible: function() {
      return this.visibleContentId == this.item.contentId;
    }
  },
  methods: {
    ...mapActions(["setSearchResults", "setScrollingReserved", "setSettings", "setScrollingReserved", "setVisibleContentId"]),
    formattedLocationData: formattedLocationData,
    getIdFromLocationData: getIdFromLocationData,
    parentsArrayPush(parentsArray) {
      let changedArray = [...parentsArray];
      changedArray.push(this.item);
      return changedArray;
    },
    displayAccordionButton() {

      // hierarchy level equal or more than setting value
      if (this.index >= this.getSettings.accordionActivationLevel) {
        // has child items
        if (this.item.items && this.item.items.length) {

          // themeWords filter or hiding is deactive, always show accordion button
          if (!this.getFilters.themeWords) return true;
          if (!this.getSettings.hideThemeWordsWithNomatches) return true;

          // has active child items or child items have active themewords
          if (this.item.childItemsActive || this.item.directChildItemsActive || this.item.childItemsThemeWordsActive || this.item.directChildItemsThemeWordsActive) { 
            return true;
          }
        }
      }
      
      return false;
    },
    /**
    * @description If current listTree item is not Johdanto, Liite or Lähteet, return ordernumber
    * @param { Array }  locationArray order number presented as array
    * @param { String } name nav-item name
    * @returns String, order number or empty string
    */
    handleHeaderNumber(locationArray, name){
      if (isNaN(locationArray[locationArray.length - 1])) {
        return "";
      }
      if(this.getheadersWithoutOrderNum.includes(name.toLowerCase())){
        return "";
      }else {
        return this.formattedLocationData(locationArray)
      }
    },
    toggleAccordion() {
      this.accordion.open = !this.accordion.open;
    },
    accordionCss(index, open) {
      let cssString = "";
      
      if (index >= this.getSettings.accordionActivationLevel) {
        cssString += "accordion-content ";

        if (open) {
          cssString += "open ";
        } else {
          cssString += "closed ";
        }
      }

      cssString += "level-" + (this.index + 1);

      return cssString;
    },
    updateUrl(location, hash) {

      // TODO: include locale info, e.g. "pathString = pathString + '?lang=' + i18n.locale"

      /* 1. Get target location info and set it into params */
      let tempLocation = [];
      if (location) { // Normal item, use locationData
        for (let i = 1; i < location.length; i++) {
          tempLocation.push(location[i]);
        }
      } else if (this.singleInfoItemIndex !== 'undefined') { // infoItem, use name
        let urlName = createUrlString(this.item.name);
        tempLocation.push(urlName)
      }

      let pushParams = {
        componentPage: this.$router.currentRoute.params.componentPage,
        componentId: tempLocation,
      }
      
      /* 2. Get possibly active filters and set them into query */
      let activeThemewords = Object.keys(this.themeWords).filter(key => this.themeWords[key] === true);
      let pushQuery = {
        themeword: activeThemewords
      }

      /* 3. Dispatch router request with parameters, e.g. /katsaus/2/0?themeword=ilmastonmuutos#22 */
      this.$router.push({
        name: 'componentpage',
        params: pushParams,
        query: pushQuery,
        hash: hash
      }).catch(err => { console.log("Reroute to same location, avoiding")})

      // Remove search results from view
      this.setSearchResults({ "errorMessage":"", "data":[] });


      // Scroll into top of main content
      this.$nextTick(() => {

        // Set visible content id (creates indicator) when item is clicked
        this.setVisibleContentId(this.item.contentId);
        
        this.setScrollingReserved(true);
        
        // If menu toggle is visible (mobile mode) close the menu
        if (jQuery('.settings-box.visual-settings:visible').length) {
          let tempSettings = {...this.getSettings};
          tempSettings.showContentWindowInFullWidth = true; // closes mobile menu 
          this.setSettings(tempSettings);
        }

        setTimeout(() => {
          let scrollTarget = jQuery('.tukave-main-content');
          scrollTarget[0].scrollIntoView({behavior: "smooth"});

          // Focus main content area
          document.getElementById('tuka-content-container').focus({
            preventScroll: true
          });

        }, 100);

        setTimeout(() => {
          this.setScrollingReserved(false);
        }, 2000)
      });

    },
    onNavClick() {
      
      // If accordion exists, load current + all child elements
      if (this.displayAccordionButton()) {
        let modifiedLocation = [...this.locationArray];
        modifiedLocation.push(0);
        this.updateUrl(modifiedLocation);
      } else {
        this.updateUrl(this.locationArray);
      }

    },
    treeItemCss() {
      let cssString = ""

      cssString += 'level-' + this.index + " ";
      
      if (this.getFilters.themeWords == false) {
        cssString += "tree-active "; // themeword filter not active
      } else {

        if (this.item.themeWordsActive) {
          cssString += "tree-active-themeword "; // item has active themeword
        } else {
          cssString += "tree-deactive ";

          if (this.getSettings.hideThemeWordsWithNomatches) {
            cssString += "tree-hidden ";
          }
        }

        if (this.item.childItemsActive) {
          cssString += "tree-parent-active ";
        }
      }
      return cssString;
    },
    navItemCss() {
      let cssString = ""

      cssString += this.isCurrentlyVisible ? 'current-visible-item ' : '';

      if (this.currentItem) {
        cssString += "current ";
      }

      if (this.activeItem) {
        cssString += "active-item ";
      }

      if (this.getFilters.themeWords == false) {
        cssString += "active "; // themeword filter not active
      } else {

        if (this.item.themeWordsActive) {
          cssString += "active-themeword "; // item has active themeword
        } else {
          cssString += "deactive ";

          if (this.getSettings.hideThemeWordsWithNomatches) {

            // Hide if item has no child items active
            if (!this.item.childItemsThemeWordsActive) {
              cssString += "hidden ";
            }
          }
        }

        // Classes for items with child items that are active
        if (this.item.childItemsActive) {
          cssString += "child-items-active ";
        }
        if (this.item.directChildItemsActive) {
          cssString += "direct-child-items-active ";
        }

        // Classes for items with child items with themewords
        if (this.item.childItemsThemeWordsActive) {
          cssString += "child-items-themewords-active ";
        }
        if (this.item.directChildItemsThemeWordsActive) {
          cssString += "direct-child-items-themewords-active ";
        }
      }

      return cssString;
    },
    decodeContent(item) {
      // Decode possible HTML entities in item.name field
      const txt = document.createElement("textarea");
      txt.innerHTML = item.name;
      item.name = txt.value
      return item;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
